export default "__VITE_ASSET__DcYAAuxT__"